
const View = {
  label: 'view',
  icon: 'remove_red_eye',
  code: 'view',
};

const Edit = {
  label: 'edit',
  icon: 'edit',
  code: 'edit',
};

const Copy = {
  label: 'copy',
  icon: 'file_copy',
  code: 'copy',
};

const Share = {
  label: 'share',
  icon: 'email',
  code: 'share',
};

const NewTemplate = {
  label: 'new template',
  icon: 'note_add',
  code: 'newTemplate',
};

const NewSubmission = {
  label: 'new job',
  icon: 'note_add',
  code: 'newSubmission',
};

const NewOrder = {
  label: 'order supplies',
  icon: 'add_shopping_cart',
  code: 'newOrder',
};

const Excel = {
  label: 'export to excel',
  icon: 'get_app',
  code: 'excel',
};

const Download = {
  label: 'download',
  icon: 'get_app',
  code: 'download',
};

const Pay = {
  icon: 'attach_money',
  label: 'pay invoice',
  code: 'pay',
};

const Cancel = {
  label: 'cancel',
  icon: 'highlight_off',
  code: 'cancel',
};

const MultiDelete = {
  label: 'MultiDelete',
  icon: 'delete',
  code: 'multiDelete',
};

const Delete = {
  label: 'delete',
  icon: 'delete',
  code: 'delete',
};

const AddTest = {
  label: 'add test',
  icon: 'add',
  code: 'addTest',
};

const Request = {
  icon: 'attach_money',
  label: 'request',
  code: 'request',
};

const PayNow = {
  icon: 'payment',
  label: 'paynow',
  code: 'paynow',
};
const Receipt = {
  icon: 'receipt',
  label: 'receipt',
  code: 'receipt',
};

export default [
  View,
  Edit,
  Copy,
  Share,
  NewTemplate,
  NewSubmission,
  NewOrder,
  Excel,
  Pay,
  Cancel,
  MultiDelete,
  Delete,
  Download,
  AddTest,
  Request,
  PayNow,
  Receipt,
];



// WEBPACK FOOTER //
// ./src/constants/menuOptions.js